// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"1dd89c03","633":"cf80f296"}[chunkId] + ".chunk.css";
};